import { MRT_Row } from "material-react-table";
import { t } from "i18next";
import { OrderRequestCateringRow } from "../Domain/OrderRequestList.types";

// Define a type alias for the union
export type CateringQuantityError = "min" | "max" | "empty" | null;

export const qtyHelperText = (
  row: MRT_Row<OrderRequestCateringRow>,
  cateringQuantityErrors: Record<number, CateringQuantityError>
) => {
  const errorType = cateringQuantityErrors[row.original.id];
  if (errorType === "min") return t("Quantity must be bigger than 0");
  if (errorType === "max") return t("Quantity must be less than or equal to the original quantity");
  if (row.original.availableQty === null || errorType === "empty")
    return t("Please select the available quantity");
  return "";
};
